import { Select } from "@/components/ui"
import { getFormField } from '../biens/SectionForm'
import { locationFormRules } from './locationsSlice'
import { useLocationForm } from './LocationFormContext'
import { typeLocationOptions } from "./options"


const FieldList = [
  // Partie 1
  {name: "prix_loyer", label: "Loyer HC", type: "currency"},
  {name: "montant_charges_syndic", label: "Syndic", type: "currency"},
  {name: "montant_charges_eau_froide", label: "Eau froide", type: "currency"},
  {name: "montant_charges_menage_commun", label: "Ménage communs", type: 'currency'},
  {name: "montant_charges_electricite_commun", label: "Electricité communs", type: 'currency'},
  {name: "montant_charges_ordures_menageres", label: "Ordures ménagères", type: 'currency'},
  {name: "montant_charges_entretien_chauffage", label: "Entretien chauffage", type: 'currency'},
  {name: "montant_charges_espaces_verts", label: "Espaces verts", type: 'currency'},
  // Partie 2 
  {name: "type_location", label: "Type de location", type: "select"},
  {name: "montant_honoraires_ttc", label: "Honoraires TTC", type: "currency"},
  {name: "montant_gli", label: "Montant GLI", type: "currency"},
  // Partie 3
  {name: "montant_depot_garantie", label: "Dépôt de garantie", type: "currency"},
  {name: "depot_garantie_conserve_agence", label: "Dépôt de garantie conservé à l'agence", type: 'toggle'},
  {name: "montant_frais_entree", label: "Frais d'entrée", type: "currency"},
]

export default () => {
  const { control, hasError, getErrorMessage, getValues } = useLocationForm()

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
      <div className="flex flex-col items-center gap-4">  
        {FieldList.slice(0, 8).map( 
          (field, index) => getFormField(control, field, index) 
        )}
        {/* <Input.Date control={control}
          label={FieldList[6].label}
          name={FieldList[6].name}
          rules={locationFormRules(getValues).date_fin_bail}
          validator={{hasError, getErrorMessage}}
        /> */}
      </div>
      <div className="flex flex-col items-center gap-4">                
        <Select.Form control={control} 
          rules={locationFormRules(getValues).type_location}
          validator={{hasError, getErrorMessage}}
          name='type_location' label="Type de location" 
          options={typeLocationOptions}
        />
        {/* <LocataireFields control={control} formErrors={formErrors} apiErrors={errors} /> */}
        {FieldList.slice(9, 11).map( 
          (field, index) => getFormField(control, field, index) 
        )}
      </div>
      <div className="flex flex-col items-center gap-4">                
        {FieldList.slice(11).map(
          (field, index) => getFormField(control, field, index)
        )}
      </div>
    </div>
  )
}